function IDE(G, D, undefined) {
    var mfp_user_cookie_name = G.mfp_user_cookie_name || "", mfp_preview_cookie_name = G.mfp_preview_cookie_name || "PID", CHANNEL = G.mfp_channel || "", server = "https://mfp.deliver.ifeng.com/mfp/mfpMultipleDelivery.do", mfp_div_prefix = "div-guru-ad-";
    function guid() {
        return ("MT" + (+new Date()).toString(16).slice(5) + (Math.random() * 1e16).toString(16)).slice(0, 16);
    }
    function noop() {}
    function setContent(ele, html) {
        //var innerSize = getInnerSize(ele), d;
        ele.innerHTML = html;
    }
    function getCookie(c_name) {
        var start = document.cookie.indexOf(c_name + "=");
        if (start == -1) {
            return "";
        }
        start = start + c_name.length + 1;
        var end = document.cookie.indexOf(";", start);
        if (end == -1) {
            end = document.cookie.length;
        }
        return decodeURIComponent(document.cookie.substring(start, end));
    }
    function get_adunitid_from_divid(div_id) {
        return div_id.slice(mfp_div_prefix.length);
    }
    function get_divid_from_adunitid(ad_id) {
        return mfp_div_prefix + ad_id;
    }
    function getReferrer() {
        var referrer = D.referrer;
        try {
            referrer = G.top.document.referrer;
        } catch (e) {
            try {
                referrer = G.parent.document.referrer;
            } catch (e2) {}
        }
        return referrer;
    }
    function display() {
        var adunitids = "";
        if (arguments.length < 1) {
            return;
        }
        var ii;
        for (ii = 0; ii < arguments.length; ii++) {
            adunitids += get_adunitid_from_divid(arguments[ii]);
            if (ii < arguments.length - 1) {
                adunitids += ",";
            }
        }
        var callbackName = guid(), url = server + "?ADUNITID=" + adunitids + "&CHANNEL=" + CHANNEL + "&jsonp=" + callbackName + "&USERID=" + getCookie(mfp_user_cookie_name) + "&PID=" + getCookie(mfp_preview_cookie_name) + G.mfp_attrs, script = D.createElement("script"), head = D.getElementsByTagName("head")[0];
        script.type = "text/javascript";
        script.charset = "utf-8";
        window[callbackName] = function(data) {
            window[callbackName] = noop;
            if (!data) {
                return;
            }
            var adId, div;
            for (adId in data) {
                adId && data[adId] && (div = D.getElementById(get_divid_from_adunitid(adId))) && setContent(div, '<!doctype html><html><head><title></title></head><body style="margin: 0px;">' + data[adId] + "</body></html>");
            }
            head.removeChild(script);
            script = null;
        };
        script.src = url;
        head.firstChild ? head.insertBefore(script, head.firstChild) :head.appendChild(script);
    }
    G.display = display;
    var a, displays = G.MFP.displays;
    displays.push = function() {
        display.apply(null, arguments);
    };
    if (displays && displays.length > 0) {
        display.apply(null, displays);
    }
}
export default IDE;